<div class="login-block" *ngIf="!loading">
  <app-logo-card></app-logo-card>
  <mat-card class="login-card">
    <mat-card-content>
      <form
        (ngSubmit)="submitLogin($event)"
        class="login-form"
        #loginForm="ngForm">
        <mat-form-field>
          <input matInput
            type="email"
            name="email"
            placeholder="E-mail"
            id="inputEmail"
            [(ngModel)]="account.email"
            #email="ngModel"
            autocomplete="username email"
            required>
          <mat-label class="form-error" *ngIf="email.errors?.required">
            メールアドレスは必須です
          </mat-label>
        </mat-form-field>

        <button mat-button
          type="submit"
          color="primary"
          [disabled]="loginForm.invalid">
          ログイン
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
<!--<app-loading *ngIf="loading"></app-loading>-->
